<template>
  <div class="full_height body-candidate">
    <div class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-5 bg-white border-bottom box-shadow">
      <img
        src="/images/Jovool_logo.png"
        style="width: 100px;"
      />
      <a
        class="btn hide btn-outline-primary"
        href="#"
      >Sign up</a>
    </div>
    <div>
      <div
        class="col-lg-12 col-xs-12"
        :class="{
          'p-0': mobile ? true : false,
        }"
      >
        <div class="AdminCandidate-background">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
export default {
  data: () => ({
    mobile: isMobile,
  }),
};
</script>
